import React, { Component } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    FormLabel,
    Box
} from '@mui/material';
import InputTextField from '../../Component/Reusables/InputTextField';


import PartnerServices from '../../Services/PartnerService';
import { ShowAlert } from "../../Component/ShowAlert";
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import { IPayOutPartner } from './Interface';


// Interface for props
interface UpdatePayoutPartnerProps {
    open: boolean;
    onClose: (state: boolean, action: string) => void;
    accessToken: string;
    refreshData: () => void;
    payoutPartnerData: IPayOutPartner;
}

interface UpdatePayoutPartnerSTate {
    partnerName: string;
    partnerNameError: string;
    loading: boolean;
    accessToken: string;
}

class UpdatePayoutPartner extends Component<UpdatePayoutPartnerProps, UpdatePayoutPartnerSTate> {
    constructor(props: UpdatePayoutPartnerProps) {
        super(props);
        const { payoutPartnerData } = props;


        this.state = {
            partnerName: payoutPartnerData.payoutPartnerName,
            accessToken: props.accessToken,
            partnerNameError: "",
            loading: false
        };
    }

    // Get access token and fetch from currencies
    async componentDidMount() {
        const accesstoken_ = await loadFromLocalStorage('accessToken');
        if (accesstoken_) {
            this.setState({
                accessToken: accesstoken_.toString()
            });
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
    }

    handleChange = (field: keyof UpdatePayoutPartnerSTate, value: string) => {
        this.setState({ [field]: value } as unknown as Pick<UpdatePayoutPartnerSTate, keyof UpdatePayoutPartnerSTate>);
    };

    validateFields = (): boolean => {
        let isValid = true;
        const { partnerName } = this.state;

        if (!partnerName.trim()) {
            this.setState({ partnerNameError: 'Payout Partner Name is required.' });
            isValid = false;
        } else {
            this.setState({ partnerNameError: '' });
        }

        return isValid;
    };

    // Method on save button click api call...
    private handleDialogAction = async (action: string) => {
        if (action === "ok") {
            if (!this.validateFields()) {
                return;
            }

            const postData = {
                partnerId: this.props.payoutPartnerData.payoutPartnerId,
                partnerName: this.state.partnerName,
            }

            this.setState({ loading: true });

            try {
                const response = await PartnerServices.editPayoutPartner(this.state.accessToken, postData);
                if (response.ok) {
                    this.setState({ loading: false });
                    this.props.onClose?.(true, action);
                    ShowAlert("Success", "Payout Partner updated successfully!.", "success")
                      .then(() => { this.props.refreshData() });
                }
            } catch (error) {
                console.error("Error updating Payout Partner:", error);
                ShowAlert("Error", "Failed to updated Payout Partner", "error");
            }
        } else this.props.onClose?.(false, action);
    };

    render() {
        const { open, onClose } = this.props;
        const { partnerName, partnerNameError, loading } = this.state;

        return (
            <Dialog
                open={open}
                onClose={() => onClose(false, 'cancel')}
                fullWidth
                maxWidth="sm"
                keepMounted
            >
                <DialogTitle>Edit Payout Partner</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormLabel className="input-field-label">Payout Partner Name</FormLabel>
                                <InputTextField
                                    placeholder="Enter partner name"
                                    value={partnerName}
                                    inputType="text"
                                    onChange={(value: string) => this.handleChange('partnerName', value)}
                                    error={!!partnerNameError}
                                    helperText={partnerNameError}
                                    disabled={loading}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDialogAction("cancel")} disabled={loading}>
                        Cancel
                    </Button>
                    <Button color="secondary" variant="contained" onClick={() => this.handleDialogAction("ok")}>
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default UpdatePayoutPartner;
